export enum VisibilityChannelPolicy {
  SEMI_PRIVATE = 'SEMI_PRIVATE',
  PRIVATE = 'PRIVATE'
}
